<template>
  <div class="page_candidate">
    <div class="videoBox">
      <video ref="videoPlayer" :controls="false" oncontextmenu="return false" :muted="true" loop x5-video-player-type="h5-page" style="width:100%;max-height:500px;object-fit: scale-down;" webkit-playsinline="true" playsinline="true" poster="" controlslist="nodownload">
        <source :src="videoUrl" type="video/mp4">
        您的浏览器不支持Video标签。
      </video>
      <div class="captions">
        <div class="captionsTxt">{{ captions }}</div>
      </div>
      <audio id="music">
        <source :src="voiceUrl" type="audio/mpeg">
        您的浏览器不支持 audio 元素。
      </audio>
    </div>
    <!-- <div class="txt01" ref="chatMessages" id="messageBody">
      <p v-for="(char, i) in pList" :key="i+'k'">
        <span v-for="(txt, index) in char" :key="index">{{txt}}</span>
        <span v-if="i == pList.length - 1" class="home-main-typed-cursor" :class="{ 'hidden': !isAnimating }">|</span>
      </p>
    </div>
    <div @click="stopAnimation">暂停</div> -->
    <div class="prompt-loader">
      <div class="em" v-for="(item,index) in 15" :key="index"></div>
    </div>

    <div class="prompt-loader">
      <div class="yj" v-for="(item,index) in 15" :key="index"></div>
    </div>
    <!-- <audio autoplay id="music" @ended="audioEnd">
      <source src="./../../assets/qt.mp3" type="audio/mpeg">
      您的浏览器不支持 audio 元素。
    </audio> -->
    <div class="flex">
      <Button type="info" @click="startRecorder()" style="margin:1vw;">开始录音</Button>

      <Button type="info" @click="stopRecorder()" style="margin:1vw;">结束录音</Button>

      <Button type="info" @click="getRecorder()" style="margin:1vw;">获取录音信息</Button>

      <Button type="info" @click="play()" style="margin:1vw;">PLAY</Button>
    </div>

  </div>
</template>

<script>
  import xz from "@/common";
  import Recorder from "js-audio-recorder";
  import {
    downloadPDF
  } from "../../utils/pdf";

  const lamejs = require("lamejs");

  const recorder = new Recorder({
    sampleBits: 16, // 采样位数，支持 8 或 16，默认是16

    sampleRate: 48000, // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值，我的chrome是48000

    numChannels: 1, // 声道，支持 1 或 2， 默认是1

    // compiling: false,(0.x版本中生效,1.x增加中) // 是否边录边转换，默认是false
  });
  // 绑定事件-打印的是当前录音数据

  recorder.onprogress = function (params) {
    // console.log('--------------START---------------')
    // console.log('录音时长(秒)', params.duration);
    // console.log('录音大小(字节)', params.fileSize);
    // console.log('录音音量百分比(%)', params.vol);
    // console.log('当前录音的总数据([DataView, DataView...])', params.data);
    // console.log('--------------END---------------')
  };
  export default {
    components: {},
    data() {
      return {
        pList: [
          []
        ],
        message: [],
        isAnimating: true,
        docPath: this.$store.state.EMP.docPath,
        videoUrl: "",
        captions: "",
        chattxt: "岗位名称:音箱测试员\n综合薪资:5000-5500\n性别要求:女\n年龄要求:25--40\n工作内容:测试音箱，手脚灵活反应快，\n吃住情况:1元1餐，不加班7.3/餐，住宿40元/月，水电费平摊有偿提供住宿食堂自费(有补贴) \n上班时间:长白班\n工作城市:浙江省宁波市鄞州区\n客服:金**\n--------------------------\n岗位名称:打单员\n综合薪资:5100-5600\n性别要求:女\n年龄要求:18--35\n工作内容:负责单据录入，打印，分发处理\n吃住情况:餐补15元/餐不包住食堂自费(有补贴) \n上班时间:长白班\n工作城市:浙江省宁波市奉化区\n客服:严**\n--------------------------\n岗位名称:营运主管（储备）\n综合薪资:5000-8000\n性别要求:男女皆可\n年龄要求:18--35\n工作内容:完成质量；各类报表，数据的汇总及分析；做好部门日常盘点，控制损耗；跟踪部门客户服务体验，推动改善客户服务KPI;促销员管理，培训及监督，促销计划落地及反馈；与相关部门做好协调工作。\n吃住情况:工作大于8小时餐补12元/天不包住食堂自费(有补贴) \n上班时间:长白班\n工作城市:浙江省宁波市北仑区\n客服:李**\n--------------------------\n岗位名称:检测岗\n综合薪资:3000-5500\n性别要求:女\n年龄要求:20--35\n工作内容:在检测中心检测工作，转正后会进行倒班，工作时间8小时三班倒。\n吃住情况:大专学历可以申请宿舍有偿提供住宿免费工作餐\n上班时间:倒班\n工作城市:浙江省宁波市鄞州区\n客服:王**\n--------------------------\n岗位名称:灶头师傅\n综合薪资:4300-5300\n性别要求:男\n年龄要求:18--35\n工作内容:按要求河流程完成档口生产任务，具备1年以上厨房工作经验，会翻锅\n吃住情况:工作大于8小时餐补12元/天不包住食堂自费(有补贴) \n上班时间:倒班\n工作城市:浙江省宁波市鄞州区\n客服:李**\n--------------------------\n",
        voiceUrl: "",
        result: {
          order: {
            Amount: 2,
            AuthWay: null,
            Bankcard: "",
            BusiId: "1631",
            BusiType: "2",
            ContractId: null,
            CreatedTime: "2023-07-10T16:32:30",
            Entcode: "",
            Entname: "",
            FinishTime: "2023-07-10T16:32:30",
            Id: "0196c483-e60e-43fb-8232-3d0104b322ea",
            InquiryAgency: null,
            IsDeletd: false,
            OrderId: "TU212900940710163229",
            ProductName: "身份信息验证",
            Progress: 2,
            ResumeId: "",
            SurveyIdcard: "330825199710274515",
            SurveyName: "张磊",
            SurveyTel: "",
            UserId: "caa39434-539c-40cb-95d6-31b215f0f9dc",
            UserName: null,
          },
          orderDetailList: [{
            Category: "身份风险",
            ErrMsg: null,
            Fee: null,
            FinishTime: "2023-07-10T16:32:30",
            Id: "4768b8d6-33ac-446e-88d0-b553a2c8728c",
            Orderid: "0196c483-e60e-43fb-8232-3d0104b322ea",
            Price: 2,
            Product: "身份信息验证",
            ProductId: "f11ea4e6-195c-4e99-9b97-44347cd61b0c",
            Progress: 2,
            ResultStr: "一致",
            ThirdParty: "华道",
            ThirdPartyReturn: '{"CODE":"200","NAME":"张磊","IDCARDCODE":"330825199710274515","TRANS_ID":"4768b8d6-33ac-446e-88d0-b553a2c8728c","FEE":"Y","RESULT":"1","RESULTDESC":"一致"}',
            ThirdPartyReturnSet: null,
          },{
            Category: "身份风险",
            ErrMsg: null,
            Fee: null,
            FinishTime: "2023-07-10T16:32:30",
            Id: "4768b8d6-33ac-446e-88d0-b553a2c8728c",
            Orderid: "0196c483-e60e-43fb-8232-3d0104b322ea",
            Price: 2,
            Product: "身份信息验证",
            ProductId: "f11ea4e6-195c-4e99-9b97-44347cd61b0c",
            Progress: 2,
            ResultStr: "一致",
            ThirdParty: "华道",
            ThirdPartyReturn: '{"CODE":"200","NAME":"张磊","IDCARDCODE":"330825199710274515","TRANS_ID":"4768b8d6-33ac-446e-88d0-b553a2c8728c","FEE":"Y","RESULT":"1","RESULTDESC":"一致"}',
            ThirdPartyReturnSet: null,
          },{
            Category: "身份风险",
            ErrMsg: null,
            Fee: null,
            FinishTime: "2023-07-10T16:32:30",
            Id: "4768b8d6-33ac-446e-88d0-b553a2c8728c",
            Orderid: "0196c483-e60e-43fb-8232-3d0104b322ea",
            Price: 2,
            Product: "身份信息验证",
            ProductId: "f11ea4e6-195c-4e99-9b97-44347cd61b0c",
            Progress: 2,
            ResultStr: "一致",
            ThirdParty: "华道",
            ThirdPartyReturn: '{"CODE":"200","NAME":"张磊","IDCARDCODE":"330825199710274515","TRANS_ID":"4768b8d6-33ac-446e-88d0-b553a2c8728c","FEE":"Y","RESULT":"1","RESULTDESC":"一致"}',
            ThirdPartyReturnSet: null,
          },{
            Category: "身份风险",
            ErrMsg: null,
            Fee: null,
            FinishTime: "2023-07-10T16:32:30",
            Id: "4768b8d6-33ac-446e-88d0-b553a2c8728c",
            Orderid: "0196c483-e60e-43fb-8232-3d0104b322ea",
            Price: 2,
            Product: "身份信息验证",
            ProductId: "f11ea4e6-195c-4e99-9b97-44347cd61b0c",
            Progress: 2,
            ResultStr: "一致",
            ThirdParty: "华道",
            ThirdPartyReturn: '{"CODE":"200","NAME":"张磊","IDCARDCODE":"330825199710274515","TRANS_ID":"4768b8d6-33ac-446e-88d0-b553a2c8728c","FEE":"Y","RESULT":"1","RESULTDESC":"一致"}',
            ThirdPartyReturnSet: null,
          },{
            Category: "身份风险",
            ErrMsg: null,
            Fee: null,
            FinishTime: "2023-07-10T16:32:30",
            Id: "4768b8d6-33ac-446e-88d0-b553a2c8728c",
            Orderid: "0196c483-e60e-43fb-8232-3d0104b322ea",
            Price: 2,
            Product: "身份信息验证",
            ProductId: "f11ea4e6-195c-4e99-9b97-44347cd61b0c",
            Progress: 2,
            ResultStr: "一致",
            ThirdParty: "华道",
            ThirdPartyReturn: '{"CODE":"200","NAME":"张磊","IDCARDCODE":"330825199710274515","TRANS_ID":"4768b8d6-33ac-446e-88d0-b553a2c8728c","FEE":"Y","RESULT":"1","RESULTDESC":"一致"}',
            ThirdPartyReturnSet: null,
          },{
            Category: "身份风险",
            ErrMsg: null,
            Fee: null,
            FinishTime: "2023-07-10T16:32:30",
            Id: "4768b8d6-33ac-446e-88d0-b553a2c8728c",
            Orderid: "0196c483-e60e-43fb-8232-3d0104b322ea",
            Price: 2,
            Product: "身份信息验证",
            ProductId: "f11ea4e6-195c-4e99-9b97-44347cd61b0c",
            Progress: 2,
            ResultStr: "一致",
            ThirdParty: "华道",
            ThirdPartyReturn: '{"CODE":"200","NAME":"张磊","IDCARDCODE":"330825199710274515","TRANS_ID":"4768b8d6-33ac-446e-88d0-b553a2c8728c","FEE":"Y","RESULT":"1","RESULTDESC":"一致"}',
            ThirdPartyReturnSet: null,
          },{
            Category: "身份风险",
            ErrMsg: null,
            Fee: null,
            FinishTime: "2023-07-10T16:32:30",
            Id: "4768b8d6-33ac-446e-88d0-b553a2c8728c",
            Orderid: "0196c483-e60e-43fb-8232-3d0104b322ea",
            Price: 2,
            Product: "身份信息验证",
            ProductId: "f11ea4e6-195c-4e99-9b97-44347cd61b0c",
            Progress: 2,
            ResultStr: "一致",
            ThirdParty: "华道",
            ThirdPartyReturn: '{"CODE":"200","NAME":"张磊","IDCARDCODE":"330825199710274515","TRANS_ID":"4768b8d6-33ac-446e-88d0-b553a2c8728c","FEE":"Y","RESULT":"1","RESULTDESC":"一致"}',
            ThirdPartyReturnSet: null,
          }, {
            Category: "身份风险",
            ErrMsg: null,
            Fee: null,
            FinishTime: "2023-07-10T16:32:30",
            Id: "4768b8d6-33ac-446e-88d0-b553a2c8728c",
            Orderid: "0196c483-e60e-43fb-8232-3d0104b322ea",
            Price: 2,
            Product: "身份信息验证",
            ProductId: "f11ea4e6-195c-4e99-9b97-44347cd61b0c",
            Progress: 2,
            ResultStr: "一致",
            ThirdParty: "华道",
            ThirdPartyReturn: '{"CODE":"200","NAME":"张磊","IDCARDCODE":"330825199710274515","TRANS_ID":"4768b8d6-33ac-446e-88d0-b553a2c8728c","FEE":"Y","RESULT":"1","RESULTDESC":"一致"}',
            ThirdPartyReturnSet: null,
          },{
            Category: "身份风险",
            ErrMsg: null,
            Fee: null,
            FinishTime: "2023-07-10T16:32:30",
            Id: "4768b8d6-33ac-446e-88d0-b553a2c8728c",
            Orderid: "0196c483-e60e-43fb-8232-3d0104b322ea",
            Price: 2,
            Product: "身份信息验证",
            ProductId: "f11ea4e6-195c-4e99-9b97-44347cd61b0c",
            Progress: 2,
            ResultStr: "一致",
            ThirdParty: "华道",
            ThirdPartyReturn: '{"CODE":"200","NAME":"张磊","IDCARDCODE":"330825199710274515","TRANS_ID":"4768b8d6-33ac-446e-88d0-b553a2c8728c","FEE":"Y","RESULT":"1","RESULTDESC":"一致"}',
            ThirdPartyReturnSet: null,
          },{
            Category: "身份风险",
            ErrMsg: null,
            Fee: null,
            FinishTime: "2023-07-10T16:32:30",
            Id: "4768b8d6-33ac-446e-88d0-b553a2c8728c",
            Orderid: "0196c483-e60e-43fb-8232-3d0104b322ea",
            Price: 2,
            Product: "身份信息验证",
            ProductId: "f11ea4e6-195c-4e99-9b97-44347cd61b0c",
            Progress: 2,
            ResultStr: "一致",
            ThirdParty: "华道",
            ThirdPartyReturn: '{"CODE":"200","NAME":"张磊","IDCARDCODE":"330825199710274515","TRANS_ID":"4768b8d6-33ac-446e-88d0-b553a2c8728c","FEE":"Y","RESULT":"1","RESULTDESC":"一致"}',
            ThirdPartyReturnSet: null,
          },{
            Category: "身份风险",
            ErrMsg: null,
            Fee: null,
            FinishTime: "2023-07-10T16:32:30",
            Id: "4768b8d6-33ac-446e-88d0-b553a2c8728c",
            Orderid: "0196c483-e60e-43fb-8232-3d0104b322ea",
            Price: 2,
            Product: "身份信息验证",
            ProductId: "f11ea4e6-195c-4e99-9b97-44347cd61b0c",
            Progress: 2,
            ResultStr: "一致",
            ThirdParty: "华道",
            ThirdPartyReturn: '{"CODE":"200","NAME":"张磊","IDCARDCODE":"330825199710274515","TRANS_ID":"4768b8d6-33ac-446e-88d0-b553a2c8728c","FEE":"Y","RESULT":"1","RESULTDESC":"一致"}',
            ThirdPartyReturnSet: null,
          },{
            Category: "身份风险",
            ErrMsg: null,
            Fee: null,
            FinishTime: "2023-07-10T16:32:30",
            Id: "4768b8d6-33ac-446e-88d0-b553a2c8728c",
            Orderid: "0196c483-e60e-43fb-8232-3d0104b322ea",
            Price: 2,
            Product: "身份信息验证",
            ProductId: "f11ea4e6-195c-4e99-9b97-44347cd61b0c",
            Progress: 2,
            ResultStr: "一致",
            ThirdParty: "华道",
            ThirdPartyReturn: '{"CODE":"200","NAME":"张磊","IDCARDCODE":"330825199710274515","TRANS_ID":"4768b8d6-33ac-446e-88d0-b553a2c8728c","FEE":"Y","RESULT":"1","RESULTDESC":"一致"}',
            ThirdPartyReturnSet: null,
          },{
            Category: "身份风险",
            ErrMsg: null,
            Fee: null,
            FinishTime: "2023-07-10T16:32:30",
            Id: "4768b8d6-33ac-446e-88d0-b553a2c8728c",
            Orderid: "0196c483-e60e-43fb-8232-3d0104b322ea",
            Price: 2,
            Product: "身份信息验证",
            ProductId: "f11ea4e6-195c-4e99-9b97-44347cd61b0c",
            Progress: 2,
            ResultStr: "一致",
            ThirdParty: "华道",
            ThirdPartyReturn: '{"CODE":"200","NAME":"张磊","IDCARDCODE":"330825199710274515","TRANS_ID":"4768b8d6-33ac-446e-88d0-b553a2c8728c","FEE":"Y","RESULT":"1","RESULTDESC":"一致"}',
            ThirdPartyReturnSet: null,
          },{
            Category: "身份风险",
            ErrMsg: null,
            Fee: null,
            FinishTime: "2023-07-10T16:32:30",
            Id: "4768b8d6-33ac-446e-88d0-b553a2c8728c",
            Orderid: "0196c483-e60e-43fb-8232-3d0104b322ea",
            Price: 2,
            Product: "身份信息验证",
            ProductId: "f11ea4e6-195c-4e99-9b97-44347cd61b0c",
            Progress: 2,
            ResultStr: "一致",
            ThirdParty: "华道",
            ThirdPartyReturn: '{"CODE":"200","NAME":"张磊","IDCARDCODE":"330825199710274515","TRANS_ID":"4768b8d6-33ac-446e-88d0-b553a2c8728c","FEE":"Y","RESULT":"1","RESULTDESC":"一致"}',
            ThirdPartyReturnSet: null,
          },],
        },
        identityReport: [],
      };
    },
    async created() {
      console.log(
        new Date().getTime() <
        new Date("2023-07-10 12:00").getTime() - 1 * 60 * 60 * 1000
      );
      let dateMoments = new Date();
      const monthFirstDates =
        dateMoments.getFullYear() +
        "-" +
        (dateMoments.getMonth() + 1) +
        "-" +
        dateMoments.getDate();
      console.log("ss", monthFirstDates);
      this.videoUrl =
        this.docPath + "85ad7fff2f7b4901845a2a3434afc244/20230526100826601.mp4";
      this.voiceUrl =
        this.$store.state.EMP.vdoPath +
        "chat85ad7fff-2f7b-4901-845a-2a3434afc244/202306160115040997.wav";
      this.$store.commit("setHiddenLeft", true);
      // this.play();
      // this.message = this.chattxt.split("");
      // console.log(this.message);
      // let i = 0;
      // let index = 0;
      // this.pList[0] = [];
      // this.$set(this.pList[0], []);
      // this.timerId = setInterval(() => {
      //   let a = this.message[index];
      //   if (index + 1 == this.message.length) {
      //     this.stopAnimation();
      //   } else {
      //     if (a != "\n") {
      //       this.pList[i].push(a);
      //       this.moveBottom();
      //     } else {
      //       i++;
      //       this.pList.push([]);
      //     }
      //     index++;
      //   }
      // }, 50);
      this.down();
    },
    mounted() {
      this.$nextTick(() => {
        this.getSmall()
      })
    },
    methods: {
      //*重复使用可以将方法单独提取js文件中，然后在页面通过import使用，此处不再概述
      //*1450是我自己的页面高度，可以声明变量
      getSmall() {
        let dom = document.getElementsByClassName("small_item");
        for (var i = 0; i < dom.length; i++) {
          console.log(i)
          if (
            i!=0 && this.offset(dom[i]).top % 841.89 > this.offset(dom[i + 1]).top % 841.89 &&
            841.89 - (this.offset(dom[i]).top % 841.89) < dom[i].offsetHeight
          ) {
            dom[i - 1].style.marginBottom =
              891.89 - (this.offset(dom[i]).top % 841.89) + "Px";
          }
        }
      },
      offset(element) {
        var pos = {
          left: 0,
          top: 0
        };
        var parents = element.offsetParent;
        pos.left += element.offsetLeft;
        pos.top += element.offsetTop;
        while (parents && !/html|body/i.test(parents.tagName)) {
          pos.left += parents.offsetLeft;
          pos.top += parents.offsetTop;
          parents = parents.offsetParent;
          console.log('offsetTop',parents.offsetTop)
        }
        console.log('pos',pos)
        return pos;
      },
      down() {
        this.result.orderDetailList.forEach((element) => {
          if (element.Product == "身份信息验证") {
            this.identityReport = [{
                name: "身份证号码",
                result: this.result.order.SurveyIdcard,
                truth: element.ResultStr,
                remark: "",
              },
              {
                name: "姓名",
                result: this.result.order.SurveyName,
                truth: element.ResultStr,
                remark: "",
              },
            ];
          } else if (element.Product == "身份+手机号验证") {
            this.telReport = [{
                name: "身份证号码",
                result: this.result.order.SurveyIdcard,
                truth: element.ResultStr,
                remark: "",
              },
              {
                name: "姓名",
                result: this.result.order.SurveyName,
                truth: element.ResultStr,
                remark: "",
              },
              {
                name: "手机号码",
                result: this.result.order.SurveyTel,
                truth: element.ResultStr,
                remark: "",
              },
            ];
          } else if (element.Product == "身份+银行卡+手机验证") {
            this.bankReport = [{
                name: "身份证号码",
                result: this.result.order.SurveyIdcard,
                truth: element.ResultStr,
                remark: "",
              },
              {
                name: "姓名",
                result: this.result.order.SurveyName,
                truth: element.ResultStr,
                remark: "",
              },
              {
                name: "手机号码",
                result: this.result.order.SurveyTel,
                truth: element.ResultStr,
                remark: "",
              },
              {
                name: "银行卡",
                result: this.encryption(this.result.order.Bankcard),
                truth: element.ResultStr,
                remark: "",
              },
            ];
          } else if (element.Product == "法院被执行人-限高版") {
            if (!that.isNull(element.ThirdPartyReturnSet)) {
              let info1 = JSON.parse(element.ThirdPartyReturnSet);
              that.$set(element, "returnSetList1", info1);
            }
            // console.log(JSON.parse(element.ThirdPartyReturnSet))
          } else if (element.Product == "法院被执行人—高级版") {
            if (!that.isNull(element.ThirdPartyReturnSet)) {
              let info2 = JSON.parse(element.ThirdPartyReturnSet);
              that.$set(element, "returnSetList2", info2);
            }
            // console.log('gj',that.result)
          } else if (element.Product == "司法诉讼分类查询(标准版)") {
            if (
              element.ThirdPartyReturn != undefined &&
              element.ThirdPartyReturn
            ) {
              const info = JSON.parse(element.ThirdPartyReturn);
              const a = JSON.parse(info.data).ppre_execut;
              if (element.ResultStr != "查无" && !this.isNull(a)) {
                this.judicialLitigation = a;
              }
            }
          } else if (element.Product == "法院信息详情-个人高级版") {
            if (
              element.ThirdPartyReturn != undefined &&
              element.ThirdPartyReturn
            ) {
              const info = JSON.parse(element.ThirdPartyReturn);
              console.log("666", info.CourtDetailPro);
              if (
                element.ResultStr != "查无" &&
                !this.isNull(info.CourtDetailPro.entryList)
              ) {
                this.personalAdvanced = info.CourtDetailPro.entryList;
              }
            }
          }
        });
      },
      handleExport() {
        const name =
          "背调报告-" + this.result.order.SurveyName + "-" + this.result.order.Id;
        setTimeout(() => {
          downloadPDF(this.$refs.pdf, name);
        }, 100);
      },
      showCaptions() {
        this.message = this.chattxt
          .replace(/--------------------------/g, "")
          .split("\n");
        console.log(this.message);
        let num = 0;
        let index = 0;
        // this.captions = this.message[0];
        this.timerId = setInterval(() => {
          num++;
          if (index == 0) {
            this.captions = this.message[index];
            index++;
          } else {
            if (
              num + 1 == this.message[index].length ||
              this.message[index] == ""
            ) {
              num = 0;
              index++;
              this.captions = this.message[index];
            }
          }
        }, 300);
      },
      moveBottom() {
        let chatHistory = document.getElementById("messageBody");

        this.$nextTick(() => {
          chatHistory.scrollTop = chatHistory.scrollHeight;
        });
        console.log(chatHistory.scrollTop, chatHistory.scrollHeight);
      },
      // 暂停动画效果
      stopAnimation() {
        clearInterval(this.timerId);
        // this.messages = []
        this.isAnimating = false;
      },
      // 开始录音
      startRecorder() {
        recorder.start().then(
          () => {},
          (error) => {
            // 出错了
            console.log(`${error.name} : ${error.message}`);
          }
        );
      },

      // 结束录音
      stopRecorder() {
        recorder.stop();
      },
      //获取录音文件
      getRecorder() {
        let toltime = recorder.duration; //录音总时长

        let fileSize = recorder.fileSize; //录音总大小

        //录音结束，获取取录音数据

        let PCMBlob = recorder.getPCMBlob(); //获取 PCM 数据

        let wav = recorder.getWAVBlob(); //获取 WAV 数据

        let channel = recorder.getChannelData(); //获取左声道和右声道音频数据

        console.log(recorder);
        let audioFile = new File([wav], "voice.mp3", {
          type: "audio/mp3"
        });
        console.log(audioFile);

        let formData = new FormData();
        formData.append("action", "save");
        formData.append("pagename", "video");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("entPicFile", audioFile, "voice.mp3");
        xz.uploadCert(formData).then((res) => {
          if (res) {
            console.log(res);
          } else {
            this.$message("文件上传失败,请稍后再试");
          }
        });
        // debugger;
      },
      play() {
        let music = document.getElementById("music");
        music.play();
        this.showCaptions();
      },
      audioEnd() {
        alert("结束辣");
      },
      // 判断在职天数是否是负数
      isMinus(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == 0 ||
          o == "NaN" ||
          Number(o) < 0
        );
      },
      isNull(o) {
        // console.log('isnull',o)
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == "NaN"
        );
      },
    },
  };
</script>
<style scoped>
  .txt01 {
    overflow-y: auto;
    height: 100px;
  }

  .home-main-typed-cursor {
    margin-left: 4px;
    font-size: 28px;
  }

  .home-main-typed-cursor {
    margin-left: 4px;
    font-size: 28px;
  }

  .is-typed-cursor-anmation {
    animation: typed 0.5s ease infinite alternate;
  }

  .hidden {
    display: none;
  }

  .prompt-loader .em {}

  /* 语音音阶------------- */
  .prompt-loader {
    width: 180px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;
    background: #fff;
    padding: 30px;
  }

  .prompt-loader .em {
    display: block;
    width: 5px;
    height: 10%;
    margin-right: 2.5px;
    float: left;
    border-radius: 5px;
  }

  .prompt-loader .em:last-child {
    margin-right: 0px;
  }

  .prompt-loader .em:nth-child(1) {
    animation: load 2.5s 1.4s infinite linear alternate;
  }

  .prompt-loader .em:nth-child(2) {
    animation: load 2.5s 1.2s infinite linear alternate;
  }

  .prompt-loader .em:nth-child(3) {
    animation: load 2.5s 1s infinite linear alternate;
  }

  .prompt-loader .em:nth-child(4) {
    animation: load 2.5s 0.8s infinite linear alternate;
  }

  .prompt-loader .em:nth-child(5) {
    animation: load 2.5s 0.6s infinite linear alternate;
  }

  .prompt-loader .em:nth-child(6) {
    animation: load 2.5s 0.4s infinite linear alternate;
  }

  .prompt-loader .em:nth-child(7) {
    animation: load 2.5s 0.2s infinite linear alternate;
  }

  .prompt-loader .em:nth-child(8) {
    animation: load 2.5s 0s infinite linear alternate;
  }

  .prompt-loader .em:nth-child(9) {
    animation: load 2.5s 0.2s infinite linear alternate;
  }

  .prompt-loader .em:nth-child(10) {
    animation: load 2.5s 0.4s infinite linear alternate;
  }

  .prompt-loader .em:nth-child(11) {
    animation: load 2.5s 0.6s infinite linear alternate;
  }

  .prompt-loader .em:nth-child(12) {
    animation: load 2.5s 0.8s infinite linear alternate;
  }

  .prompt-loader .em:nth-child(13) {
    animation: load 2.5s 1s infinite linear alternate;
  }

  .prompt-loader .em:nth-child(14) {
    animation: load 2.5s 1.2s infinite linear alternate;
  }

  .prompt-loader .em:nth-child(15) {
    animation: load 2.5s 1.4s infinite linear alternate;
  }

  @keyframes load {
    0% {
      height: 10%;
      background: #19bd92;
    }

    50% {
      height: 100%;
      background: red;
    }

    100% {
      height: 10%;
      background: #19bd92;
    }
  }

  .prompt-loader .em:last-child {
    margin-right: 0px;
  }

  .yj {
    background-color: #67c23a;
    display: block;
    width: 7px;
    height: 40px;
    margin-right: 2.5px;
    float: left;
    border-radius: 5px;
  }

  .yj:nth-child(1),
  .yj:nth-child(15) {
    animation: tiao 0.5s 2s infinite linear alternate;
  }

  .yj:nth-child(2),
  .yj:nth-child(14) {
    animation: tiao 0.5s 1.8s infinite linear alternate;
  }

  .yj:nth-child(3),
  .yj:nth-child(13) {
    animation: tiao 0.5s 1.6s infinite linear alternate;
  }

  .yj:nth-child(4),
  .yj:nth-child(12) {
    animation: tiao 0.5s 1.4s infinite linear alternate;
  }

  .yj:nth-child(5),
  .yj:nth-child(11) {
    animation: tiao 0.5s 1.2s infinite linear alternate;
  }

  .yj:nth-child(6),
  .yj:nth-child(10) {
    animation: tiao 0.5s 1s infinite linear alternate;
  }

  .yj:nth-child(7),
  .yj:nth-child(9) {
    animation: tiao 0.5s 0.8s infinite linear alternate;
  }

  .yj:nth-child(8) {
    animation: tiao 0.5s 0.4s infinite linear alternate;
  }

  @keyframes tiao {
    0% {
      transform: scale(1, 1);
      background-color: #67c23a;
    }

    100% {
      transform: scale(1, 0.2);
      background-color: #f56c6c;
    }
  }

  .videoBox {
    position: relative;
    width: 1158px;
  }

  .captions {
    position: absolute;
    bottom: 10px;
    width: 100%;
    font-size: 28px;
    color: #fff;
  }

  .captionsTxt {
    width: 70%;
    text-align: center;
    margin: 0 auto;
  }

  .result_report_box {
    width: 100%;
    background: #fff;
    display: flex;
    justify-content: center;
    opacity: 1;
  }

  .result_report {
    padding: 10px 100px 30px;
    margin: 0 auto;
  }

  .page_backgroundCheck {
    min-height: calc(100vh - 84px);
    background: #f3f3f3;
    padding: 12px 16px;
  }

  .diaTitle {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 10px;
  }

  .weight {
    font-weight: bolder;
  }

  .note_txt {
    padding-right: 10px;
  }

  .note_txt p {
    line-height: 24px;
  }

  .readDialog {
    height: 500px;
    overflow-y: scroll;
    position: relative;
    padding: 20px 0 0 20px;
  }

  .dialogFoot {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    background: #f3f3f3;
  }

  .tips {
    padding-left: 15px;
  }

  .tips p {
    font-size: 13px;
  }

  .flagIsAuthorize {
    padding-left: 12px;
    margin-bottom: 12px;
  }

  .rpTirle {
    font-size: 48px;
    text-align: center;
    width: 100%;
    font-weight: bold;
  }

  .rpContent {
    text-align: center;
    width: 100%;
    margin: 24px 0;
    font-size: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dot {
    border-radius: 100%;
    background: #19bd92;
  }

  .dot1 {
    width: 8px;
    height: 8px;
  }

  .dot2 {
    width: 12px;
    height: 12px;
    margin: 0 8px;
  }

  .dot3 {
    width: 16px;
    height: 16px;
  }

  .statement {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 18px;
  }

  .logo img {
    width: 175px;
    margin-top: 20px;
  }

  .resultTitle {
    height: 36px;
    line-height: 36px;
    font-size: 15px;
    font-weight: 600;
    margin: 24px 0;
    width: 1000px;
  }

  .tableTitle {
    width: 1001px;
    color: #fff;
    background: #19bd92;
    text-align: center;
    height: 36px;
    line-height: 36px;
    font-size: 16px;
  }
</style>